<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Resource</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Resource</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                data-toggle="modal"
                id=""
                name="nam1"
                @click="addResClick('new', 0)"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <table
            class="
              table
              display
              table-bordered
              text-center
              table-striped
              no-wrap
            "
            id="clmtable1"
          >
            <thead class="thead-dark">
              <tr>
                <th>Action</th>
                <th>Display Name</th>
                <th>Resource Name</th>
                <th>Available</th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(res, ndx01) in aResList" :key="res.resourceId">
                <td>
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-warning"
                      data-toggle="modal"
                      @click="addResClick('edit', ndx01)"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="
                        btn btn-warning
                        dropdown-toggle dropdown-toggle-split
                      "
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu animated flipInY">
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        data-toggle="modal"
                        @click="getResoucePatient(res.resourceId)"
                        data-target="#resourcePatients"
                        >Patients</a
                      >
                      <a
                       @click="resourceArchive(res)"
                        class="dropdown-item"
                        href="javascript:void(0)"
                        id="resourcesArchive"
                        name="resourcesArchive"
                        >Archive</a
                      >
                    </div>
                  </div>
                </td>
                <td>{{ res.resourceStrId }}</td>
                <td>{{ res.name }}</td>
                <td>{{ res.resourceUsed}}</td>
                <td>{{ res.qty }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->

    <!-- Resource *99* -->
    <div
      id="resourceID"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modalHeader() }}</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="row">
                <div class="col">
                  <!-- Resource ID -->
                  <div
                    class="form-group"
                    v-bind:class="[
                      aSingleRes.resourceStrId.length > 0 ? 'focused' : '',
                    ]"
                  >
                    <span class="p-float-label">
                    <InputText
                      maxlength="5"
                      name=""
                      class="form-control float-class"
                      id=""
                      required=""
                      type="text"
                      v-model="aSingleRes.resourceStrId"
                    />
                    <span class="bar"></span>
                    <label for="" id="font1">Display Name<span  style="color:red"> *</span></label>
                    </span>
                  </div>
                  <!-- Resource ID -->
                </div>
                <div class="col">
                  <!-- Resource Name -->
                  <div
                    class="form-group"
                    v-bind:class="[aSingleRes.name.length > 0 ? 'focused' : '']"
                  >
                    <span class="p-float-label">
                    <InputText
                      name=""
                      class="form-control float-class"
                      id=""
                      maxlength="100"
                      required=""
                      type="text"
                      v-model="aSingleRes.name"
                    />
                    <span class="bar"></span>
                    <label for="" id="font1">Resource Name<span  style="color:red"> *</span></label>
                    </span>
                  </div>
                  <!-- Resource Name -->
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <!-- Total -->
                  <div class="form-group">
                    <p class="font-weight-bolder">Total<span  style="color:red"> *</span></p>
                    <input
                      v-mask="'##########'"
                      v-model="aSingleRes.qty"
                      class="vertical-spin"
                      type="number"
                      data-bts-button-down-class="btn btn-secondary btn-outline"
                      data-bts-button-up-class="btn btn-secondary btn-outline"
                      name="vertical-spin"
                    />
                  </div>
                  <!-- Total -->
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="saveResourceButtonClick" id="createRes_btn"
              name="createRes_btn"
              class="btn btn-outline-success waves-effect waves-light col-12"
            >
              {{ modalButtonCaption() }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Resource -->

    <!-- Resource Patients Modal -->
    <div
      class="modal bs-example-modal-lg fade"
      id="resourcePatients"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Patients</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>

          <div class="modal-body mb-1 pt-2">
            <div class="table-responsive">
              <table
                class="
                  table
                  display
                  table-bordered
                  text-center
                  table-striped
                  no-wrap
                "
                id="resourcePat"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Action</th>
                    <th>Name</th>
                    <th>Current Stage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="valR in resourcePat" :key="valR.visitId">
                    <td>
                       <label class="switch text-center">
                          <input
                            class=""
                            type="checkbox"
                            v-model="valR.isCaptured"
                            @change="actionChange(valR)"
                          />
                          <span class="slider round"></span>
                        </label>
                    </td>
                    <td>
                      {{ valR.firstName }} {{ valR.lastName }} <br />{{
                        valR.dob.split('T')[0]
                      }}
                    </td>
                    <td>{{ valR.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--<div class="modal-footer">
                    <button type="button" class="btn btn-outline-success waves-effect col-12" data-dismiss="modal">Update Resources</button>
                </div>-->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- Resource Patients Modal -->
  </div>
</template>

<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";

export default {
  name: "Resource",

  data() {
    return {
      //loader
      loader: "",
    //Timer
      TimerObject: {},
      aResList: "",
      resourcePat: [],
      aSingleRes: {
        resourceId: 0,
        resourceStrId: "",
        name: "",
        qty: 0,
        practiceId: 0,
      },

      myData: "",
      EmployeeRolesStr: [],
      updButton: 1
    };
  },

  methods: {
     //------------------------------------------ Common Methods
    resourceArchive(res)
    {
      Swal.fire({
              title: "Are you sure?",
              text: "This can't be undone",
              showConfirmButton: false,
              showDenyButton: true,
              showCancelButton: true,
              denyButtonText: "Yes, Archive it!",
            }).then((result) => {
              if (result.isDenied) {
                this.intDummyComm();
                this.resourceArchiveAxios(res);
              }
            });
    },
    async resourceArchiveAxios(res) {
      const obj = {
        DC: this.dummyComm,
        RES: res
      };
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });                   
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Stages/archiveresource",
        data: obj,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
         var response  = res.data;
          if(response.status == true)
          {//
            this.successToastUpd();

          }
          else
          { 
            //show error
            this.errorToastUpd();
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
         this.ResetLogoutTime();
         this.loadInit();
         loader.hide();  
        });
    }, // axiosGetData 
    actionChange(res){
     //debugger
      this.intDummyComm();
      this.dummyComm.extras = "";
      if( res.alreadyChanged == true)
      {
        this.dummyComm.extras2 =res.alreadyChanged ;
      }
      res.alreadyChanged = true;     
      this.dummyComm.extras1 = res.isCaptured;
      this.dummyComm.extras = res.pndx;
      this.dummyComm.visitId = res.visitId;
      this.dummyComm.resourceName = res.resourceName;
      this.dummyComm.resourceStrVal = res.resourceStrId;
      this.dummyComm.resourceId = res.resourceId;
       res.alreadyChanged = true;
      let url = "";
      url = this.SERVER + "/VNSPRAAPI/Patient/ResourcePatUpd";

      const myDat = this.dummyComm;
      this.axiosGetData(url, myDat, 4);
    },
    getResoucePatient(resourceId) {
      let url = "";
      url = this.SERVER + "/VNSPRAAPI/Patient/Get_resourcePat";
      this.intDummyComm();
      this.dummyComm.extras = "";

      const myData = { dc: this.dummyComm, ResourceId: resourceId };
      this.axiosGetData(url, myData, 3);
    },
    
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    
    handleRole(){
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
             if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Resource'
     );
       if(this.val[0].canCreate == 0){ $('button[name="nam1').hide(); }
       if(this.val[0].canUpdate == 0){$('button[name="createRes_btn').hide();}
       if(this.val[0].canDelete == 0){$('resourcesArchive').hide();}
    }
    },
    
    saveResourceButtonClick() {
      let obj = this.aSingleRes;
      for(let i=0;i<this.aResList.length;i++){
      if(this.aResList[i].resourceId == this.aSingleRes.resourceId){
        if(this.aResList[i].qty > this.aSingleRes.qty){
          this.ShowErrorAutoClose("Total Quantity must be Greater.");
          return;
        }
      }
      }
      if (obj.resourceStrId === "" || obj.name === "" || obj.qty === 0) {
        this.ShowWarning(
          "Resource ID, Name and Quantity cannot be left blank."
        );
        return;
      }
        $( "#createRes_btn" ).prop( "disabled", true );
      let url = "";
      if (obj.resourceId <= 0) url = this.SERVER + "/VNSPRAAPI/Stages/AddRes";
      else url = this.SERVER + "/VNSPRAAPI/Stages/UpdtRes";

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = localStorage.xeon;
      const myData = { dc: this.dummyComm, res: this.aSingleRes };
      this.axiosGetData(url, myData, 2);
    },

    modalHeader() {
      return this.aSingleRes.resourceId <= 0 ? "Resource" : "Update Resource";
    },

    modalButtonCaption() {
      return this.aSingleRes.resourceId <= 0 ? "Create" : "Update Resource";
    },

    addResClick(what, ndx) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      if (what === "new") {
        this.aSingleRes.resourceId = 0;
        this.aSingleRes.name = "";
        this.aSingleRes.resourceStrId = "";
        this.aSingleRes.qty = 0;
      } else {
        this.aSingleRes = JSON.parse(JSON.stringify(this.aResList[ndx]));
      }

      $("#resourceID").modal("show");
      loader.hide();
    },

 loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
 },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Stages/GtResList";

      this.axiosGetData(url, this.dummyComm, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, myData, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
           //debugger
            this.myData = res.data;
            this.aResList = res.data.rbl;
          } else if (what === 2) {
            if (res.data.dc.auditFlag < 0) {
              createToast("Display Name Already exist", {
                type: "danger",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
            } else {
              this.myData = res.data;
              this.aResList = res.data.rbl;
              createToast("Information Added", {
                type: "success",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
              $("#resourceID").modal("hide");
            }
          } else if (what === 3) {
            if (res.data.dc.auditFlag > 0) {
             //debugger // eslint-disable-line no-debugger
              this.resourcePat = res.data.resourceListPat;
            }
          }
          else if (what === 4) {
              this.successToastUpd();
          }
          $( "#createRes_btn" ).prop( "disabled", false );
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
         this.ResetLogoutTime();
         loader.hide();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
        clearTimeout(this.TimerObject);
      },

  watch: {
    "aSingleRes.resourceStrId": function (val) {
      this.aSingleRes.resourceStrId = val.toUpperCase();
    },

    "aSingleRes.qty": function (val) {
      if (val < 0) this.aSingleRes.qty = 0;
    },

    aResList: function () {
      $("#clmtable1").DataTable().destroy();
      this.$nextTick(() => {
        try {
          $("#clmtable1").DataTable({
            pageLength: 50,
            lengthMenu: [
              [50, 100, 500, 1000, 2000],
              [50, 100, 500, 1000, 2000],
            ],
          });
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $(".clmtable1").DataTable().draw();
        } catch {
          return -1;
        }
      }); // this.$nextTick
    },

    resourcePat: function () {
      $("#resourcePat").DataTable().destroy();
      this.$nextTick(() => {
        try {
          $("#resourcePat").DataTable({});
          $(
            ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
          ).addClass("btn btn-primary mr-1");
          $(".resourcePat").DataTable().draw();
        } catch {
          return -1;
        }
      }); // this.$nextTick
    },
  }, // watch
};
</script>

<style>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #00c292;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  height: 34px;
  width: 60px;
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<style scoped>
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* / border-bottom: 2px solid rgb(240, 141, 11); / */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1{
    font-weight: 600;
    font-size: 15px;
    margin-left: -7px;
}
</style>